import { allOptionAsUndefinedTramsform } from './all-option-as-undefined.transform'
import { emptyNumberAsUndefinedTramsform } from './empty-number-as-undefined.transform'
import { emptyStringAsUndefinedTramsform } from './empty-string-as-undefined.transform'

export const setupValidation = () => {
  emptyNumberAsUndefinedTramsform()
  emptyStringAsUndefinedTramsform()
  allOptionAsUndefinedTramsform()
}
